// extracted by mini-css-extract-plugin
module.exports = {"subNavMenu":"SubNavMenu_subNavMenu__R2e0j","subNavNotch":"SubNavMenu_subNavNotch__nJ_I6","subNavList":"SubNavMenu_subNavList__1k0fI"};